import List from "@/components/list";
import router from "@/router";

const Table = args => {

  // 查看考试学员名单
  function examUserList(exam) {
    router.push({
      path: "/examResult/members",
      query: {
        id: exam.uuid,
        examType: exam.examType,
        status: exam.examStatus,
        bizId: exam.bizId
      }
    });
  }

  // 跳转试卷详情
  function goPaperDetail(item) {
    router.push({ path: "/examPaper/detail", query: { id: item.paperId } });
  }
  // 跳转考试详情
  function goDetails(item) {
    router.push({ path: "/examInfo/detail", query: { id: item.uuid } });
  }

  const PaperName = ({ props: { vo } }) => {
    return (
      <div class="base-hover-char" onClick={() => goPaperDetail(vo.row)}>
        {vo.row.paperName}
      </div>
    );
  };

  const ExamTime = ({ props: { vo } }) => {
    return (
      <div>
        <span>{vo.row.limitStartTime ? vo.row.limitStartTime:'~'}</span>
        <span>&nbsp;至&nbsp;{vo.row.limitEndTime ? vo.row.limitEndTime:'~'}</span>
      </div>
    );
  };

  const Deal = ({ props: { vo } }) => {
    const exam = vo.row;
    const dealConf = [
      ["icon-message", "考试详情", () => goDetails(exam), ""],
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
        <el-tooltip content="考试学员名单" placement="top" v-permission="examReault:userList">
          <i class="icon-user-list" onClick={() => examUserList(exam)}></i>
        </el-tooltip>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "试卷名称",
      prop: "paperName",
      minWidth: "220",
      fixed: 'left',
      // render: (vo) => <PaperName vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "考试类型",
      prop: "examTypeName",
      width: "90",
      showOverflowTooltip: true
    },
    {
      label: "考试状态",
      prop: "examStatusName",
      width: "90",
      showOverflowTooltip: true
    },
    {
      label: "考试时间",
      width: "230",
      prop: 'limitTime'
    },
    {
      label: "关联班级",
      prop: "bizName",
      minWidth: "180",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "180",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      fixed: "right",
      width: "100",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
